export default __webpack_public_path__ + "static/barbados_mega_6-2b44419f7f1a17d7cfce1f89a28b8346.png";